export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const SET_ENTITY = "SET_ENTITY";
export const ADD_ENTITY = "ADD_ENTITY";
export const UPDATE_ENTITY = "UPDATE_ENTITY";
export const DELETE_ENTITY = "DELETE_ENTITY";
export const RESET_LIST_DT_STATE = "RESET_LIST_DT_STATE";
export const UPDATE_LIST_PER_PAGE = "UPDATE_LIST_PER_PAGE "
export const RESET_DT_STATE = "RESET_DT_STATE";
export const RESET_USER_STATE = "RESET_USER_STATE";